<template>
  <Row style="padding: 5px">
    <Form ref="formData" :model="formData" :rules="rules">

      <Row>
        <Col :xs="24" :sm="24" :md="12"  class="left__col">
          <!-- LEGAL NAME -->
          <FormItem :label="getSchema('legal_name').label" prop="legal_name">
            <Input v-model="formData.legal_name" :placeholder="getSchema('legal_name').label"></Input>
          </FormItem>

          <!-- LEGAL FULL NAME -->
          <FormItem :label="getSchema('legal_full_name').label" prop="legal_full_name">
            <Input v-model="formData.legal_full_name" :placeholder="getSchema('legal_full_name').label"></Input>
          </FormItem>

          <!-- ADDRESS LEGAL -->
          <FormItem :label="getSchema('address_legal').label" prop="address_legal">
            <Input v-model="formData.address_legal" :placeholder="getSchema('address_legal').label"></Input>
          </FormItem>

          <!-- ADDRESS ACTUAL -->
          <FormItem :label="getSchema('address_actual').label" prop="address_actual">
            <Input v-model="formData.address_actual" :placeholder="getSchema('address_actual').label"></Input>
          </FormItem>

          <!-- INN -->
          <FormItem :label="getSchema('inn').label" prop="inn">
            <!-- <Input v-model="formData.inn" :placeholder="getSchema('inn').label"></Input> -->
            <Input
              type="text" 
              v-model="formData.inn" 
              :placeholder="getSchema('inn').label"
              v-mask="'############'"
              style="width: 100%"
            >
          </Input>
          </FormItem>


        </Col>
        <Col :xs="24" :sm="24" :md="12" class="right__col">
          <!-- HEAD POSITION -->
          <FormItem :label="getSchema('head_position').label" prop="head_position">
            <Input v-model="formData.head_position" :placeholder="getSchema('head_position').label"></Input>
          </FormItem>

          <!-- HEAD NAME -->
          <FormItem :label="getSchema('head_name').label" prop="head_name">
            <Input v-model="formData.head_name" :placeholder="getSchema('head_name').label"></Input>
          </FormItem>

          <!-- ACCOUNTANT HEAD -->
          <FormItem :label="getSchema('accountant_name').label" prop="accountant_name">
            <Input v-model="formData.accountant_name" :placeholder="getSchema('accountant_name').label"></Input>
          </FormItem>

          <!-- VAT PAYER -->
          <FormItem prop="vat_payer">
            <div class="switch-custom">
              <i-switch v-model="formData.vat_payer">
              </i-switch>
              <span>{{getSchema('vat_payer').label}}</span>
            </div>

          </FormItem>

          <!--VAT SERIES-->
          <FormItem v-if="displayVATparams" :label="getSchema('vat_series').label" prop="vat_series">
            <Input
              v-model="formData.vat_series"
              :placeholder="getSchema('vat_series').label"
            ></Input>
          </FormItem>

          <!--VAT NUMBER-->
          <FormItem v-if="displayVATparams" :label="getSchema('vat_number').label" prop="vat_number">
            <Input
              v-model="formData.vat_number"
              :placeholder="getSchema('vat_number').label"
            ></Input>
          </FormItem>

          <!--VAT RATE-->
          <FormItem v-if="displayVATparams" :label="getSchema('vat_rate').label" prop="vat_rate">
            <InputNumber
              :min="0"
              v-model="formData.vat_rate"
              :placeholder="getSchema('vat_rate').label"
              style="width: 100%"
            ></InputNumber>
          </FormItem>

        </Col>
      </Row>






      <FormItem class="text-right">
        <Button type="success" @click="saveAction()" :disabled="disabledSaveButton">Сохранить</Button>
      </FormItem>

    </Form>
    <Spin size="large" fix v-if="loading"></Spin>
  </Row>
</template>

<script>
  import {base_url} from '../../http.js'
  import { mask } from "vue-the-mask";

  export default {
    name: "companyExtraSettings",
    directives: {
            mask
        },
    
    data() {
      return {
        loading: true,
        baseViewUrl: base_url + '/company/requisites/',
        schema: {},
        rules: {
          inn:{
            required: true,
            // type: "number",
            message: "ИНН должен состоять из 12 цифр",
            trigger: "change",
            pattern: /^[0-9]{12}$/,
          }
        },
        validForm: false,
        isChanged: false,

        formData: {
          legal_name: '',
          legal_full_name: '',
          address_legal: '',
          address_actual: '',
          inn: '',
          head_position: '',
          head_name: '',
          accountant_name: '',
          vat_payer: '',
          vat_series: '',
          vat_number: '',
          vat_rate: null
        },
      }
    },

    computed: {
      disabledSaveButton() {
        return !this.isChanged || !this.validForm;
      },
      displayVATparams(){
        return this.formData.vat_payer
      }
    },

    // watch: {
    //   'formData.legal_name': function (val, oldVal) {
    //     this.validateForm();
    //   }
    // },

    methods: {
      fetchSchema() {
        this.$http
          .options(this.baseViewUrl)
          .then(response => {
            this.schema = response.data.actions.PUT;
            this.getRules();
          })
      },

      fetchInitialData() {
        this.$http
          .get(this.baseViewUrl)
          .then(response => {
            this.formData = response.data;

            for (let field in this.formData) {
              this.formData[field] = response.data[field];
            }

            this.fetchSchema();
          })
                .finally(() => {
                  this.loading = false;
                });
      },

      getSchema(name) {
        return this.schema[name];
      },

      validateForm() {
        this.$refs.formData.validate((valid) => {
          this.validForm = valid;
        });
      },

      saveAction() {
        if (this.validForm) {
          this.save();
        } else {
          this.$Message.error('Некорректно заполнены поля!');
        }
      },

      save() {
        this.loading = true;
        this.$http
          .put(this.baseViewUrl, this.formData)
          .then(response => {
            this.$Message.success('Успешно сохранено');
            this.isChanged = false;
          })
          .finally(() => {
            this.loading = false;
          })
          .catch(error => {
            this.$Notice.open({
                      title: 'Ошибка',
                      desc: 'Для редактирования организации необходимо закрыть все смены на кассах организации'
          });

      });
      },

      getRules() {
        for (let field in this.schema) {
          if (this.schema[field].required) {
            this.rules[field] = [
              {
                required: true,
                message: this.schema[field].help_text,
                trigger: 'blur'
              }
            ];

            // this.$watch('formData.' + field, function (newValue, oldValue) {
            //   this.validateForm();
            // });

          }
          this.$watch('formData.' + field, function (newValue, oldValue) {
            this.validateForm();
            this.isChanged = true;
          });

        }
        // this.validateForm();
      },
    },
    watch: {
      'formData.vat_payer': function(val){
        if (!val) {
          this.formData.vat_series = '';
          this.formData.vat_number = '';
          this.formData.vat_rate = null;
        }
      }
    },
    created() {
      this.fetchInitialData();
    },
    mounted() {
      // this.validateForm();
    }
  }
</script>

<style scoped>
.left__col {
  padding-right: 50px;
  border-right: 1px dashed rgba(14, 37, 74, 0.3)
}

  .right__col {
    padding-left: 50px;
  }

@media screen and (max-width: 767px) {
  .left__col {
    padding-right: 0;
    border: none;
  }

  .right__col {
    padding-left: 0;
  }

  .text-right {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/company/companyExtraSettings.vue